import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "sonner";
import { RootState, actions } from "../state/reducer";
import PanelSubHeading from "../components/panel/subHeading";
import { closeModal, openModal } from "../state/modalSlice";
import CreateEventModal from "../modals/event/createEvent";
import { defPageSize } from "../constants/events";
import EventListCard from "../components/events/eventCard";
import { EventCardInfo, EventData, PaginatorCallback } from "../types";
import TotalStatsRoundDiagram from "../components/statistics/roundDiagrm";
import { backend, eventBackend, statsBackend } from "../services";
import { generateRandomString, getMonthAndYear } from "../utils";
import { EventListRequestParams } from "../forms/filters/event";
import Paginator from "../components/paginator";
import SalePlanHomeDiagram from "../components/statistics/planHomeDiagram";
import PanelPage from "../components/panel/panelPage";
import PanelSearch from "../components/filters/panelSearch";
import { FilterIcon } from "../icons/filter";
import CustomerFilterModal from "../modals/filters/client";
import {
  CustomerListFilters,
  defaultCustomerFilters,
} from "../forms/filters/customers";
import ClientListTable from "../components/activity/clientListTable";
import { defaultTaskFilters } from "../forms/filters/task";
import TasksListWidget from "../components/widgets/taskListWidget";
import ClientsListWidget from "../components/widgets/clientListWidget";
import SalePlanNoCalcDiagram from "../components/statistics/planDiagreamNoCalc";
import EventSearchBlockWidget from "../components/widgets/eventSearchSubWidget";

const defaultEventsRequestParams: EventListRequestParams = {
  order_dir: "DESC",
  limit: defPageSize,
  offset: 0,
};

const HomePage = () => {
  const State = useSelector((state: RootState) => state);
  const dispatch = useDispatch();
  const [eventCards, setEventCards] = useState<EventCardInfo[]>([]);
  const [eventsCount, setEventsCount] = useState(0);
  const [totalValues, setTotalValuse] = useState<{
    plan: number;
    fact: number;
  }>({
    plan: 0,
    fact: 0,
  });
  const { session, rights } = State;

  const [searchValue, setSearchValue] = useState("");
  const [update, triggerUpdate] = useState(true);

  const filters = State.customerFilters;

  const search = (value: string) => {
    console.log(value);
    setSearchValue(value);
    dispatch(
      actions.customerRequestParams({ ...filters, search_query: value })
    );
  };

  /* useEffect(() => {
    if (!session) return;
    const filters: EventListRequestParams = {
      ...defaultEventsRequestParams,
      user_id: session.id,
    };
    const clientFilters = {
      ...defaultCustomerFilters,
      user_id: session.id,
    }
    const taskFilters = {
      ...defaultTaskFilters,
      user_id: session.id
    }
    dispatch(actions.eventRequestParams(filters));
    dispatch(actions.customerRequestParams(clientFilters));
    dispatch(actions.taskRequestParams(taskFilters))
  }, [session]); */

  useEffect(() => {
    // Если пользователь - руководитель, в план продаж идет общий показатель
    if (rights.rang < 3) {
      // Все группы
      statsBackend
        .getTotalGroupsSalePlan()
        .then((res) => {
          if (res.value)
            setTotalValuse({
              plan: res.value.total_plan,
              fact: res.value.total_actual,
            });
        })
        .catch((e) => {
          console.log("Error:", e);
        });
      return;
    }
    if (rights.rang < 7 && rights.group_ids.length > 0) {
      // Группа пользователя
      console.log("Groups:", rights.group_ids); // rights.group_ids[0]
      statsBackend
        .getSinglelGroupsSalePlan(Math.min(...rights.group_ids))
        .then((res) => {
          console.log("Group sales:", res, res.values);
          if (res.values)
            setTotalValuse({
              plan: res.values.plan_value,
              fact: Number(res.values.actual_value),
            });
        })
        .catch((e) => {
          console.log("Error:", e);
        });
    }
  }, [rights]);

  useEffect(() => {
    const session = State.session;
    if (!session) return;
    eventBackend
      .getEventCards(session.id, State.eventListRequestParams)
      .then((res) => {
        setEventCards(res.events);
      })
      .catch((e) => {
        toast("Не удалось загрузить события");
      });
    const { offset, limit, ...filterForCount } = State.eventListRequestParams;
    eventBackend.getAllEventsCount(filterForCount).then((res) => {
      setEventsCount(res.count);
    });
  }, [State.selectedItem, State.eventListRequestParams]);

  const handleOpenModal = () => {
    console.log("Called");
    dispatch(
      openModal({
        component: CreateEventModal,
        context: {
          defaultResponsibleId: session?.id,
          onSave: () => {
            dispatch(actions.selectItem(generateRandomString(4)));
            console.log("Onsave called");
          },
          closeModal: () => dispatch(closeModal()), // Закрыть модальное окно через Redux
        },
      })
    );
  };

  const handleApplyPage: PaginatorCallback = (data) => {
    const filters: EventListRequestParams = {
      ...State.eventListRequestParams,
      offset: data.page * data.perPage,
      limit: data.perPage,
    };
    dispatch(actions.eventRequestParams(filters));
  };

  const { month, year } = getMonthAndYear(new Date());

  return (
    <PanelPage>
      <div className="panelColumnFull homePage">
        <div className="flex between w100 panelColumnFull">
          <div className="columnCenter gap16 panelColumn2">
            <div className="panel eventListPanel">
              <div className="columnCenter">
                <div className="flex between w100">
                  <PanelSubHeading text="Запланированные события" />
                  <div className="panelBtnContainer">
                    <div
                      className="btn panelActionBtn"
                      onClick={handleOpenModal}
                    >
                      <span style={{ display: "flex", whiteSpace: "nowrap" }}>
                        <span style={{ marginTop: -1, marginRight: 3 }}>+</span>
                        <span>Создать событие</span>
                      </span>
                    </div>
                  </div>
                </div>
                <EventSearchBlockWidget />
                <div className="toDoHeadingBorder" />
                <div className="toDoHeading">Что нужно сделать</div>
                {eventCards.map((event: EventCardInfo, index) => {
                  return <EventListCard {...event} key={`hmpe${index}`} />;
                })}
                <div className="flex cardPaginator">
                  {eventsCount > 5 && (
                    <Paginator
                      perPage={5}
                      count={eventsCount}
                      onDataChange={handleApplyPage}
                    />
                  )}
                </div>
              </div>
            </div>
            <div className="panel eventListPanel">
              <ClientsListWidget shorted={true} />
            </div>
          </div>
          <div
            className="columnCenter gap16 panelColumn2"
            style={{ alignItems: "flex-end" }}
          >
            <TotalStatsRoundDiagram />
            <TasksListWidget shorted={true} />
            {rights.rang < 7 && totalValues.plan > 0 && (
              <SalePlanNoCalcDiagram
                enableSettings={false}
                month={month}
                year={year}
                fact={totalValues.fact}
                plan={totalValues.plan}
                title={`План продаж ( ${
                  rights.rang < 3 ? "Все отделы" : "Отдел"
                } )`}
              />
            )}
            {rights.rang > 6 && <SalePlanHomeDiagram />}
          </div>
        </div>
      </div>
    </PanelPage>
  );
};

export default HomePage;
